export default __webpack_public_path__ + "static/media/placeholder_dummy2016-moebelbauer01-de.bf022ac1.png";